<template>
  <div class="job-parts container-fluid" v-if="job">
    <div class="job-parts__head row">
      <div class="job-parts__head__adr col-auto">
        <button
          class="d-flex align-items-center pl-0"
          @click="
            $router.push({
              name: 'JobAssemblingDetail',
              params: { jobId: job.id, jobData: job },
            })
          "
        >
          <img :src="icon('chevron.svg')" class="rotate-180 mr-sm" />
          {{ job.locations[0].street }},
          {{ `${job.locations[0].postal_code} ${job.locations[0].city}` }} /
          {{
            job.type == app.options.Job.TYPE.servicing
              ? "Serviceauftrag"
              : "Montage"
          }}
        </button>
      </div>
      <div class="col-auto" v-if="job.added_manually != 2">
        <toggle-switch
          @on="toggleMontage = 1"
          @off="toggleMontage = 0"
          :label="
            job.type == app.options.Job.TYPE.servicing
              ? 'Service Ansicht'
              : 'Montage' + ' Ansicht'
          "
        >
          <!-- ? 'Serviceauftrag' -->
        </toggle-switch>
      </div>
      <div class="job-parts__head__buttons col-auto">
        <button
          v-if="job.status == app.options.Job.STATUS.cancelled"
          class="btn btn-secondary btn-icon"
          disabled
        >
          <img :src="icon('cross-circle-red.svg')" />
          <span
            >{{
              job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montage"
            }}
            abgebrochen</span
          >
        </button>
        <button
          v-else-if="job.status == app.options.Job.STATUS.unfinished"
          class="btn btn-secondary btn-icon"
          disabled
        >
          <img :src="icon('warning-important.svg')" />
          <span
            >{{
              job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montage"
            }}
            unvollständig abgeschlossen</span
          >
        </button>
        <button
          v-else-if="job.status == app.options.Job.STATUS.finished"
          class="btn btn-secondary btn-icon"
          disabled
        >
          <img :src="icon('check-circle-green.svg')" />
          <span
            >{{
              job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montage"
            }}
            abgeschlossen</span
          >
        </button>

        <template v-else>
          <button
            class="btn btn-highlighted mr-mdsm"
            @click="closeJob(true, $event)"
          >
            {{
              job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montage"
            }}
            abbrechen
          </button>
          <button
            :class="{
              btn: true,
              'btn-next': doneCompletely,
              'btn-highlighted': doneAny && !doneCompletely,
            }"
            :disabled="!doneAny"
            @click="closeJob(false, $event)"
          >
            {{
              (job.type == app.options.Job.TYPE.servicing
                ? "Serviceauftrag"
                : "Montage") +
              (doneCompletely ? " abschließen" : " unvollständig abschließen")
            }}
          </button>
        </template>
      </div>
    </div>
    <div class="overflow-auto" v-if="toggleMontage == 1">
      <table class="table mt-3 w-100 white-bg">
        <thead>
          <tr class="th-items">
            <th
              @click="
                orderLocation(
                  'location_floor',
                  locationFloorSort ? 'desc' : 'asc'
                )
              "
              scope="col"
            >
              Geschoss
              <span v-html="iconArrow"></span>
            </th>
            <th
              scope="col"
              @click="
                orderLocation(
                  'location_position',
                  locationPositionSort ? 'desc' : 'asc'
                )
              "
            >
              Position
              <span v-html="iconArrow"></span>
            </th>
            <th
              colspan="2"
              @click="orderDimension(0, dimensionSort[0] ? 'desc' : 'asc')"
              scope="col"
            >
              Größen
              <span v-html="iconArrow"></span>
            </th>
            <th
              @click="orderDimension(2, dimensionSort[2] ? 'desc' : 'asc')"
              scope="col"
            >
              Mauerstärke
              <span v-html="iconArrow"></span>
            </th>
            <th
              @click="orderDimension(4, dimensionSort[4] ? 'desc' : 'asc')"
              scope="col"
            >
              Bodeneinstand
              <span v-html="iconArrow"></span>
            </th>
            <th
              @click="orderDimension(3, dimensionSort[3] ? 'desc' : 'asc')"
              scope="col"
            >
              Anzahl Bänder
              <span v-html="iconArrow"></span>
            </th>
            <th
              colspan="2"
              @click="orderFittings(1, fittingSort[0] ? 'desc' : 'asc', 0)"
              v-if="categoryDefaultFitting.includes(1)"
              scope="col"
            >
              Türblätter
              <span v-html="iconArrow"></span>
            </th>
            <th
              colspan="2"
              @click="orderFittings(3, fittingSort[1] ? 'desc' : 'asc', 1)"
              v-if="categoryDefaultFitting.includes(3)"
              scope="col"
            >
              Festteile
              <span v-html="iconArrow"></span>
            </th>
            <th
              colspan="2"
              @click="orderFittings(2, fittingSort[2] ? 'desc' : 'asc', 2)"
              v-if="categoryDefaultFitting.includes(2)"
              scope="col"
            >
              Beschläge
              <span v-html="iconArrow"></span>
            </th>
          </tr>
          <tr class="sub-table">
            <th scope="row">&nbsp;</th>
            <td>&nbsp;</td>
            <td>Breite iL</td>
            <td>Höhe iL</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td v-if="categoryDefaultFitting.includes(1)">Titel</td>
            <td v-if="categoryDefaultFitting.includes(1)">Anzahl</td>
            <td v-if="categoryDefaultFitting.includes(3)">Titel</td>
            <td v-if="categoryDefaultFitting.includes(3)">Anzahl</td>
            <td v-if="categoryDefaultFitting.includes(2)">Titel</td>
            <td v-if="categoryDefaultFitting.includes(2)">Anzahl</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in job.parts" v-bind:key="index">
            <td>{{ item.location_floor }}</td>
            <td>
              {{ item.location_position }}
              <span v-if="item.report">
                <img
                  v-if="item.report.status == 0"
                  :src="icon('warning-important.svg')"
                />
                <img v-else :src="icon('check-circle-green.svg')" />
              </span>
            </td>
            <td>
              <span
                v-for="(dimension, index2) in getDimensions(
                  item.dimensions,
                  0,
                  1
                )"
                v-bind:key="index2"
              >
                {{
                  dimension.value + " " + (dimension.unit ? dimension.unit : "")
                }}
              </span>
            </td>
            <td>
              <span
                v-for="(dimension, index2) in getDimensions(
                  item.dimensions,
                  1,
                  2
                )"
                v-bind:key="index2"
              >
                {{
                  dimension.value + " " + (dimension.unit ? dimension.unit : "")
                }}
              </span>
            </td>
            <td>
              <span
                v-for="(dimension, index2) in getDimensions(
                  item.dimensions,
                  2,
                  3
                )"
                v-bind:key="index2"
              >
                {{
                  dimension.value + " " + (dimension.unit ? dimension.unit : "")
                }}
              </span>
            </td>
            <td>
              <span
                v-for="(dimension, index2) in getDimensions(
                  item.dimensions,
                  4,
                  5
                )"
                v-bind:key="index2"
              >
                {{
                  dimension.value + " " + (dimension.unit ? dimension.unit : "")
                }}
              </span>
            </td>
            <td>
              <span
                v-for="(dimension, index2) in getDimensions(
                  item.dimensions,
                  3,
                  4
                )"
                v-bind:key="index2"
              >
                {{
                  dimension.value + " " + (dimension.unit ? dimension.unit : "")
                }}
              </span>
            </td>
            <td v-if="categoryDefaultFitting.includes(1)">
              <p
                class="m-0"
                style="font-size: 10px"
                v-for="(fitting, index2) in getFittings(
                  item.fittings,
                  1,
                  index
                )"
                v-bind:key="index2"
              >
                {{ fitting.title }}
              </p>
            </td>
            <td v-if="categoryDefaultFitting.includes(1)">
              <p
                class="m-0"
                style="font-size: 10px"
                v-for="(fitting, index2) in getFittings(
                  item.fittings,
                  1,
                  index
                )"
                v-bind:key="index2"
              >
                {{ fitting.amount + " Stück" }}
              </p>
            </td>
            <td v-if="categoryDefaultFitting.includes(3)">
              <p
                class="m-0"
                style="font-size: 10px"
                v-for="(fitting, index2) in getFittings(
                  item.fittings,
                  3,
                  index
                )"
                v-bind:key="index2"
              >
                {{ fitting.title }}
              </p>
            </td>
            <td v-if="categoryDefaultFitting.includes(3)">
              <p
                class="m-0"
                style="font-size: 10px"
                v-for="(fitting, index2) in getFittings(
                  item.fittings,
                  3,
                  index
                )"
                v-bind:key="index2"
              >
                {{ fitting.amount + " Stück" }}
              </p>
            </td>
            <td v-if="categoryDefaultFitting.includes(2)">
              <p
                class="m-0"
                style="font-size: 10px"
                v-for="(fitting, index2) in getFittings(
                  item.fittings,
                  2,
                  index
                )"
                v-bind:key="index2"
              >
                {{ fitting.title }}
              </p>
            </td>
            <td v-if="categoryDefaultFitting.includes(2)">
              <p
                class="m-0"
                style="font-size: 10px"
                v-for="(fitting, index2) in getFittings(
                  item.fittings,
                  2,
                  index
                )"
                v-bind:key="index2"
              >
                {{ fitting.amount + " Stück" }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="toggleMontage == 0" class="job-parts__main pt-2">
      <div class="job-parts__body row" ref="body">
        <div class="job-parts__floors col-auto">
          <h2>Geschoss</h2>
          <ul>
            <li>
              <button
                @click="setFloor(null)"
                :class="{ active: !floorSelected }"
              >
                Alle
                <div>
                  <img
                    v-if="done && !doneCompletely"
                    :src="icon('warning-important.svg')"
                  />
                  <img v-if="done" :src="icon('check-circle-green.svg')" />
                </div>
              </button>
            </li>
            <li v-for="(parts, floor) in partsGroupedByFloor" :key="floor">
              <button
                @click="setFloor(floor)"
                :class="{ active: floorSelected == floor }"
              >
                {{ floor }}

                <div>
                  <img
                    v-if="
                      parts.some(
                        (part) => part.report && part.report.status == 0
                      )
                    "
                    :src="icon('warning-important.svg')"
                  />
                  <img
                    v-else-if="
                      parts.every(
                        (part) => part.report && part.report.status == 1
                      )
                    "
                    :src="icon('check-circle-green.svg')"
                  />
                </div>
              </button>
            </li>
          </ul>
        </div>

        <div class="job-parts__parts col-auto">
          <h2>Position</h2>

          <ul>
            <li v-for="part in parts" :key="part.id">
              <button
                @click="setPart(part)"
                :class="{ active: partSelected == part }"
              >
                {{ part.location_position }}

                <div v-if="part.report">
                  <img
                    v-if="part.report.status == 0"
                    :src="icon('warning-important.svg')"
                  />
                  <img v-else :src="icon('check-circle-green.svg')" />
                </div>
              </button>
            </li>
          </ul>
        </div>

        <div class="job-parts__buttons col-auto">
          <h2>Unterlagen</h2>

          <ul>
            <li>
              <button
                @click="
                  $windows.showFilesWindow(
                    'Dokumente',
                    selectedPartFiles,
                    null,
                    null,
                    'full'
                  )
                "
                :disabled="!partSelected || !selectedPartFiles.length"
              >
                Dokumente
              </button>
            </li>
            <!--<li><button @click="$windows.showFilesWindow('Türpläne', partSelected.files)" :disabled="!partSelected || !partSelected.files.length">Türpläne</button></li>-->
            <li>
              <button
                @click="showDetails = 'props'"
                :class="{ active: showDetails == 'props' }"
                :disabled="
                  !partSelected ||
                  job.added_manually == 2 ||
                  !partSelected.dimensions ||
                  !partSelected.dimensions.length
                "
              >
                Eigenschaften
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'fittings';
                  showDetailsCategory = 2;
                "
                :class="{
                  active: showDetails == 'fittings' && showDetailsCategory == 2,
                }"
                :disabled="
                  !partSelected ||
                  !selectedPartFittings[2] ||
                  !selectedPartFittings[2].length
                "
              >
                Beschläge
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'fittings';
                  showDetailsCategory = 3;
                "
                :class="{
                  active: showDetails == 'fittings' && showDetailsCategory == 3,
                }"
                :disabled="
                  !partSelected ||
                  !selectedPartFittings[3] ||
                  !selectedPartFittings[3].length
                "
              >
                Festteile
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'fittings';
                  showDetailsCategory = 1;
                "
                :class="{
                  active: showDetails == 'fittings' && showDetailsCategory == 1,
                }"
                :disabled="
                  !partSelected ||
                  !selectedPartFittings[1] ||
                  !selectedPartFittings[1].length
                "
              >
                Türblätter
              </button>
            </li>
            <li>
              <button
                :disabled="!notizen"
                @click="showDetails = 'notizenDetails'"
                :class="{
                  active: showDetails == 'notizenDetails',
                }"
              >
                Notizen
              </button>
            </li>
            <li>
              <button
                @click="
                  showDetails = 'messages';
                  showDetailsCategory = 4;
                "
                :class="{
                  active: showDetails == 'messages' && showDetailsCategory == 4,
                }"
                :disabled="!partSelected || !messages || messages.length == 0"
              >
                Historie
              </button>
            </li>
            <li class="mt-mdsm">
              <button
                :class="{ 'btn-next': partSelected != null }"
                :disabled="!partSelected"
                @click="doReport"
              >
                Erfassen
              </button>
            </li>
          </ul>
        </div>

        <div class="job-parts__details col-auto" v-if="showDetails">
          <h2>Details</h2>

          <div v-if="showDetails == 'notizenDetails'">
            <div class="row">
              <div class="col col-12">
                <div class="card">
                  <h2 class="title-sec"><strong>Beschreibung</strong></h2>
                  <div v-html="notizen"></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showDetails == 'props'">
            <div class="row">
              <div class="col col-12">
                <div class="card">
                  {{
                    `${partSelected.location_floor} - ${partSelected.location_position}`
                  }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <div class="card">
                  <h3>Dimensionen</h3>

                  <ul
                    v-if="partSelected.dimensions"
                    class="list-reset list-h job-parts__details__dimensions"
                  >
                    <li
                      v-for="(dimension, index) in partSelected.dimensions"
                      :key="index"
                      class="mr-xl"
                    >
                      {{ dimension.extDesc || dimension.id }}<br />
                      {{
                        `${dimension.strValue || dimension.value} ${
                          dimension.unit ||
                          __(
                            "jobs.components.fittings.list.common.fitting_unit_default"
                          )
                        }`
                      }}
                    </li>
                  </ul>
                  <i v-else>Keine Dimensionen angegeben.</i>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="showDetails == 'messages'">
            <div class="row">
              <div class="col col-12">
                <!-- class="card mb-xs" -->
                <div v-for="message in messages" class="p-0" :key="message.id">
                  <collapsible
                    :class="
                      'checklist-collapsible ' +
                      (!message.data ? 'hide-collapse-btn' : '')
                    "
                    class-head="container-fluid"
                    class-head-inner="row m-0"
                    :close-on-head-click="true"
                  >
                    <template slot="head">
                      <div
                        class="
                          title
                          d-flex
                          justify-content-between
                          w-100
                          row
                          m-0
                        "
                      >
                        <h2 class="col-8 pl-0">
                          {{ dateOutput(message.created_at) }}
                          {{
                            __(
                              `messages.jobs.common.${message.sourceTypeName}.${
                                job.type == app.options.Job.TYPE.servicing &&
                                message.sourceTypeName ==
                                  "job_close_without_text"
                                  ? "service_title"
                                  : "title"
                              }`
                            )
                          }}
                        </h2>

                        <small :class="'date' + ' col-4 pr-0 text-right'"
                          >{{ message.trigger_user.name }}
                          {{ dateOutput(message.updated_at) }}</small
                        >
                      </div>
                    </template>

                    <template slot="body">
                      <template v-if="message.data">
                        <div class="row w-100 pb-3">
                          <div class="col-9">
                            <span v-if="message.context_info.part">
                              {{ message.context_info.part.name }}
                              {{
                                message.data.check_title
                                  ? " | " + message.data.check_title
                                  : ""
                              }}
                              {{ message.data.text ? " | " : "" }}
                              <span
                                class="text"
                                v-html="message.data.text"
                              ></span>
                            </span>
                          </div>
                          <div class="col-3">
                            <!-- <div
                              class=""
                              v-for="(item, index) in messages"
                              :key="index"
                            > -->
                            <div
                              v-for="(img, index2) in message.data.pictures"
                              :key="index2"
                              class="mb-2"
                            >
                              <img :src="img.path" :alt="img.name" v-if="img" />
                              <div v-else class="no-img">
                                <img :src="icon('camera.svg')" />
                              </div>
                            </div>
                            <!-- </div> -->
                          </div>
                        </div>
                      </template>
                    </template>
                  </collapsible>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="showDetails == 'fittings'">
            <div
              class="row"
              v-for="fitting in selectedPartFittings[showDetailsCategory]"
              :key="fitting.id"
            >
              <div class="col col-12">
                <div class="card">
                  <h3 class="mb-xs">
                    {{ fitting.title }} |
                    {{
                      `${fitting.amount} ${
                        fitting.unit ||
                        __(
                          "jobs.components.fittings.list.common.fitting_unit_default"
                        )
                      }`
                    }}
                  </h3>

                  <ul
                    v-if="fitting.dimensions"
                    class="list-reset list-h job-parts__details__dimensions"
                  >
                    <li
                      v-for="(dimension, index) in fitting.dimensions"
                      :key="index"
                      class="mr-xl"
                    >
                      {{ dimension.extDesc || dimension.id }}<br />
                      {{
                        `${dimension.strValue || dimension.value} ${
                          dimension.unit ||
                          __(
                            "jobs.components.fittings.list.common.fitting_unit_default"
                          )
                        }`
                      }}
                    </li>
                  </ul>
                  <i v-else>Keine Dimensionen angegeben.</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        v-if="bodyScrollLeft"
        class="scroll-left"
        @click="showDetails = null"
      >
        <img :src="icon('chevron.svg')" />
      </button>
    </div>
  </div>
</template>

<script>
import JobViewBase from "./ViewBase";
import anime from "animejs";
import JobCancelReasonWindow from "../../windows/JobCancelReason";
import JobRatingWindow from "smartdoors-shared/js/components/Jobs/JobRating";
import JobMessage from "./JobMessage";
import { toDate } from "smartdoors-shared/js/helpers/common";
import LoadsImages from "../../mixins/LoadsImages";
import api from "../../helper/api";

export default {
  extends: JobViewBase,
  mixins: [LoadsImages],

  data() {
    return {
      floorSelected: null,
      partSelected: null,
      showDetails: null,
      showDetailsCategory: null,
      bodyScrollLeft: 0,
      toggleMontage: 0,
      categoryFitting: [],
      categoryDefaultFitting: [1, 2, 3],
      locationPositionSort: false,
      locationFloorSort: false,
      dimensionSort: [false, false, false, false, false],
      fittingSort: [false, false, false],
      preselectedPartId: null,
      iconArrow:
        '<svg width="0.8em" height="0.8em" viewBox="0 0 16 16" class="bi bi-arrow-down-up" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/></svg>',
    };
  },
  components: {
    "job-message": JobMessage,
  },
  computed: {
    partsGroupedByFloor() {
      const floorGroups = {};
      for (const part of this.job.parts) {
        if (!(part.location_floor in floorGroups)) {
          floorGroups[part.location_floor] = [];
        }

        floorGroups[part.location_floor].push(part);
      }
      return floorGroups;
    },
    parts() {
      this.preselectedPartId = this.$route.query.partID
        ? this.setPart(this.$route.query.partID)
        : null;
      return this.floorSelected
        ? this.partsGroupedByFloor[this.floorSelected]
        : this.job.parts;
    },
    selectedPartDimensions() {
      if (!this.partSelected) {
        return null;
      }

      const dimensions = [];

      Object.entries(this.config.jobs.parts.dimensions).forEach(
        ([key, label]) => {
          if (key in this.partSelected.dimensions) {
            dimensions.push({
              label: label,
              value: this.partSelected.dimensions[key],
            });
          }
        }
      );
      return dimensions.length ? dimensions : null;
    },
    selectedPartFittings() {
      const fittings = {};

      for (const fitting of this.partSelected.fittings) {
        if (!(fitting.category in fittings)) {
          fittings[fitting.category] = [];
        }

        fittings[fitting.category].push(fitting);
      }

      return fittings;
    },

    selectedPartFiles() {
      let files = this.partSelected.location_files;
      for (const fitting of this.partSelected.fittings) {
        files = files.concat(fitting.files);
      }

      return files;
    },
    done() {
      return this.job.parts.every((part) => part.report);
    },
    doneAny() {
      return this.job.parts.some((part) => part.report);
    },
    doneCompletely() {
      return this.job.parts.every(
        (part) => part.report && part.report.status == 1
      );
    },
    notizen() {
      let notizen = null;
      notizen = this.partSelected
        ? this.partSelected.location_position_desc
        : null;
      return notizen;
    },
    messages() {
      const messages = this.job.messages_technician;
      let filtredMessages = messages.filter((item) => {
        if (item.context_info["part"] !== undefined) {
          if (item.data.pictures && item.data.pictures.length > 0) {
            for (let i = 0; i < item.data.pictures.length; i++) {
              let picture = item.data.pictures[i];
              const pictureDownloadApiPath =
                this.config.api.urls.files.download + "/" + picture.route;
              Vue.set(picture, "path", null);
              ((pic) => {
                api.download(pictureDownloadApiPath).then((url) => {
                  Vue.set(pic, "path", url);
                });
              })(picture);
            }
            // return srcImg + "";
          }
          if (item.context_info.part.id === this.partSelected.id) return item;
        }
      });

      return filtredMessages;
    },
  },
  watch: {
    bodyScrollLeft: function (scrollLeft) {
      anime({
        targets: this.$refs.body,
        scrollLeft: scrollLeft,
        easing: "linear",
        duration: 200,
      });
    },
  },
  created() {
    this.resizeListener = () => {
      if (this.$refs.body) {
        const scrollWidth =
          this.$refs.body.scrollWidth - this.$refs.body.clientWidth;

        if (this.bodyScrollLeft != scrollWidth) {
          this.bodyScrollLeft = scrollWidth;
        }
      }
    };
    window.addEventListener("resize", this.resizeListener);
  },
  updated() {
    this.resizeListener();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeListener);
  },
  methods: {
    orderFittings(category, type, item) {
      this.fittingSort[item] = !this.fittingSort[item];
      this.job.parts.sort(this.dynamicsortFittings(category, type));
    },
    dynamicsortFittings(category, order) {
      var sort_order = 1;
      if (order === "desc") {
        sort_order = -1;
      }
      return function (a, b) {
        let suma = 0;
        let sumb = 0;

        for (let i = 0; i < a["fittings"].length; i++) {
          if (a["fittings"][i].category == category) {
            suma += a["fittings"][i].amount;
          }
        }
        for (let i = 0; i < b["fittings"].length; i++) {
          if (b["fittings"][i].category == category) {
            sumb += b["fittings"][i].amount;
          }
        }
        if (suma < sumb) {
          return -1 * sort_order;
        } else if (suma > sumb) {
          return 1 * sort_order;
        } else {
          return 0 * sort_order;
        }
      };
    },
    orderDimension(dimension, type) {
      this.dimensionSort[dimension] = !this.dimensionSort[dimension];
      this.job.parts.sort(this.dynamicsortDimension(dimension, type));
    },
    dynamicsortDimension(property, order) {
      var sort_order = 1;
      if (order === "desc") {
        sort_order = -1;
      }
      return function (a, b) {
        if (
          a["dimensions"] &&
          b["dimensions"] &&
          a["dimensions"][property] &&
          b["dimensions"][property] &&
          a["dimensions"][property].value &&
          b["dimensions"][property].value
        ) {
          if (
            a["dimensions"][property].value < b["dimensions"][property].value
          ) {
            return -1 * sort_order;
          } else if (
            a["dimensions"][property].value > b["dimensions"][property].value
          ) {
            return 1 * sort_order;
          } else {
            return 0 * sort_order;
          }
        }
        return 0 * sort_order;
      };
    },

    dynamicsort(property, order) {
      var sort_order = 1;
      if (order === "desc") {
        sort_order = -1;
      }
      return function (a, b) {
        if (a[property] < b[property]) {
          return -1 * sort_order;
        } else if (a[property] > b[property]) {
          return 1 * sort_order;
        } else {
          return 0 * sort_order;
        }
      };
    },
    orderLocation(location, type) {
      if (location == "location_floor") {
        this.locationFloorSort = !this.locationFloorSort;
      }
      if (location == "location_position") {
        this.locationPositionSort = !this.locationPositionSort;
      }
      this.job.parts.sort(this.dynamicsort(location, type));
    },
    getDimensions(dimensions, from, to) {
      let res = dimensions.slice(from, to);
      return res;
    },
    getFittings(itemFittings, category, index) {
      const fittings = itemFittings.filter((x) => x.category == category);
      if (fittings.length > 0 && !this.categoryFitting.includes(category)) {
        this.categoryFitting.push(category);
      }
      if (index == this.job.parts.length - 1) {
        this.categoryDefaultFitting = this.categoryFitting;
      }
      return fittings;
    },
    setFloor(floor) {
      this.floorSelected = floor;
      this.showDetails = null;
      this.partSelected = null;
    },

    setPart(part) {
      if (Number.isInteger(part * 1)) {
        let parts = this.job.parts;
        this.partSelected = parts.filter((pa) => {
          return pa.id == part * 1;
        })[0];
        return;
      }
      this.partSelected = part;
    },
    doReport() {
      if (this.partSelected) {
        if (this.partSelected.report) {
          // TODO: show report in details section
          this.$router.push({
            name: "JobReport",
            params: { jobId: this.job.id, partId: this.partSelected.id },
          });
        } else {
          this.$router.push({
            name: "JobReport",
            params: { jobId: this.job.id, partId: this.partSelected.id },
          });
        }
      }
    },
    async closeJob(cancel = false, $triggerEvent = null) {
      if (cancel || !this.doneCompletely) {
        const closeStatus = cancel
          ? this.app.options.Job.STATUS.cancelled
          : this.app.options.Job.STATUS.unfinished;

        const result = await this.$windows.showWindow(
          JobCancelReasonWindow,
          {
            jobCloseStatus: closeStatus,
            translationsKeyPaths: [
              "jobs.windows.cancel_reason.common",
              `jobs.windows.cancel_reason.${this.job.typeName}`,
            ],
          },
          $triggerEvent ? $triggerEvent.target : null
        );

        if (result) {
          setTimeout(() => {
            this.job.status = closeStatus;
            this.app.isLoading = false;
          }, 1000);
          this.app.isLoading = true;

          await this.$store.dispatch(
            "jobs/closeJob",
            Object.assign(this.job, {
              status: closeStatus,
              message: result,
            })
          );

          this.job.status = closeStatus;
          this.app.isLoading = false;
        }
      } else {
        const rating = await this.$windows.showWindow(JobRatingWindow, {
          type: "technician",
          size: "full",
          terms:
            this.app.options.RatingTerm.TERMS[
              this.app.options.RatingTerm.CATEGORY.technician
            ],
          userPicture: this.job.manager.profile.picture,
          allowMessage: false,
          iconSrc: this.icon,
          translationsKeyPaths: [
            "jobs.common.rating",
            "jobs.windows.rating.common",
            `jobs.windows.rating.${this.job.typeName}`,
          ],
        });

        if (rating) {
          setTimeout(() => {
            this.job.status = this.app.options.Job.STATUS.finished;
            this.app.isLoading = false;
          }, 1000);
          this.app.isLoading = true;

          await this.$store.dispatch(
            "jobs/closeJob",
            Object.assign(this.job, {
              status: this.app.options.Job.STATUS.finished,
              generate_pdf: true,
              rating,
            })
          );

          this.job.status = this.app.options.Job.STATUS.finished;
          this.app.isLoading = false;
        }
      }
    },

    dateOutput(dateString) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const date = toDate(dateString);

      return (
        date.toLocaleDateString(undefined, options) +
        " (" +
        date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
        }) +
        ")"
      );
    },
  },
};
</script>

<style lang="scss">
.job-parts {
  background: #f8f9fa;
  min-height: -webkit-fill-available;

  h2 {
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, regular);
    color: $bg-dark;
  }

  i {
    color: $bg-dark;
  }

  .card {
    padding-left: map-get($spacers, sm);
    padding-right: map-get($spacers, sm);
    height: 100%;
  }
  .title-sec {
    color: #111;
    font-size: 0.8rem;
  }
  &__head {
    justify-content: space-between;

    &__adr {
      font-weight: map-get($font-weights, medium);
      font-size: map-get($font-sizes, md);
    }

    &__buttons {
      flex: 0 1 auto;
    }
  }

  &__main {
    position: relative;

    button.scroll-left {
      position: absolute;
      left: map-get($spacers, md);
      top: 0;
      background-color: $white;
      border: 1px solid $black;
      border-radius: 50%;
      padding: 8px;
      line-height: 0;
      transform: rotate(180deg);
      img {
        padding-left: 3px;
        padding-right: 1px;
      }
    }
  }

  &__body {
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow: hidden;

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      border-radius: 6px;
      overflow: auto;
      li {
        button {
          border-bottom: 1px solid #dbdbdb;
          color: #111;
          &:disabled {
            color: rgba(0, 0, 0, 0.4);
          }
          &.btn-next{
            color: $white;
          }
        }
        &:last-child {
          button {
            border-bottom: none;
          }
        }
      }
      button {
        padding: 1rem map-get($spacers, mdsm);
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: space-between;
        margin: 0 !important;

        > div {
          flex: 1 0 auto;
          text-align: right;
          padding-right: map-get($spacers, mdsm);

          > img {
            margin-left: map-get($spacers, sm);
          }
        }

        &::after {
          content: url("~smartdoors-shared/img/icons/chevron.svg");
          flex: 0 1 auto;
        }
        &:not(.btn-next) {
          background-color: $white;
          margin: map-get($spacers, xs);
        }

        &:hover,
        &.active {
          &:not(:disabled) {
            background-color: $accent1;
            color: $white;

            &::after {
              content: url("~smartdoors-shared/img/icons/chevron-white.svg");
            }
          }
        }
      }
    }

    > div {
      min-width: 190px;

      &.job-parts__buttons {
        min-width: 230px;
        ul li:nth-last-of-type(-n + 2) button {
          border: none;
        }
      }
      &.job-parts__details {
        flex: 1 0 570px;
        min-width: 570px;
        .card {
          background-color: white;
        }
      }
    }
  }

  &__details {
    @include set-gutter-spacing(map-get($spacers, mdsm));
  }
  .job-parts__body {
    .job-parts__details {
      ul {
        padding-left: 20px !important;
        list-style: disc;
        list-style-position: outside;
      }
    }
    ul {
      border-radius: 6px;
      overflow: auto;
      li {
        &:last-child {
          button {
            border: none;
          }
        }
      }
    }
    .collapsible--closed:hover > .collapsible__head:not(.no-hover),
    .collapsible--open > .collapsible__head:not(.no-hover) {
      background-color: white;
    }
    .collapsible--open
      > .collapsible__head
      > .collapsible__buttons
      > .collapsible__btn-toggle {
      margin-top: -10px;
      display: flex;
    }
    .hide-collapse-btn {
      .collapsible__buttons {
        display: none;
      }
    }
    .checklist-collapsible {
      background: white;
      border-radius: 6px;
      overflow: auto;
      margin-bottom: 1rem;
      .no-img {
        background-color: #f8f9fa;
        padding: 2rem;
        display: inline-block;
        margin: 0.5rem;
      }
      .collapsible__body__inner {
        padding: 0 1rem;
      }
      .title {
        padding: 1rem 0;
        h2 {
          margin: 0;
          font-size: 1rem;
          line-height: unset;
          font-weight: 600;
          color: #111;
        }
      }
      .collapsible__head__inner {
        margin-right: 2rem !important;
      }

      .collapsible__buttons {
        visibility: initial;
        position: absolute;
        top: 20px;
        width: 20px;
        right: 10px;

        .collapsible__btn-toggle::after {
          animation: none;
          height: 10px;
          content: "";
          background-image: url("~smartdoors-shared/img/icons/arrow-dropdown.svg");
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          margin-top: -10px;
        }
      }
    }
  }
}
.sub-table {
  font-size: 12px;
  td {
    font-weight: 100;
  }
}
.th-items {
  background-color: black;
  color: white;

  th {
    text-align: inherit;
    border: 1px solid white;
    &:hover {
      cursor: pointer;
    }
    span {
      float: right;
    }
  }
}
.white-bg {
  background: $white;
}
table th,
td {
  padding: 0 10px;
}
table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
  border-top: 1px solid #929191;
  border-bottom: 1px solid #929191;
}
</style>